/** Studio YouTube id. The player must never receive anything else. */
export const DEFAULT_STUDIO_VIDEO_ID = "SjNQQ26gZGI";

export function isStudioYouTubeId(id) {
  return typeof id === "string" && /^[A-Za-z0-9_-]{11}$/.test(id);
}

/** Accept an 11-character id or a watch/embed/youtu.be URL. Anything else is null. */
export function studioVideoIdFromInput(urlOrId) {
  if (typeof urlOrId !== "string") return null;
  const value = urlOrId.trim();
  if (!value) return null;
  if (isStudioYouTubeId(value)) return value;
  const match = value.match(
    /(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return match ? match[1] : null;
}

/**
 * While the learner is typing, only a real id may reach the player.
 * An emptied field snaps back to the default immediately.
 * A partial id stays in the draft and leaves the current video alone.
 */
export function nextStudioVideoDraft(raw, defaultVideoId = DEFAULT_STUDIO_VIDEO_ID) {
  const parsed = studioVideoIdFromInput(raw);
  if (parsed) return { videoId: parsed, draft: parsed, commit: true };
  if (typeof raw !== "string" || raw.trim() === "") {
    return { videoId: defaultVideoId, draft: defaultVideoId, commit: true };
  }
  return { videoId: null, draft: raw, commit: false };
}

/** Leaving the field with anything unusable restores the default id. */
export function studioVideoDraftOnBlur(raw, defaultVideoId = DEFAULT_STUDIO_VIDEO_ID) {
  const parsed = studioVideoIdFromInput(raw);
  if (parsed) return { videoId: parsed, draft: parsed };
  return { videoId: defaultVideoId, draft: defaultVideoId };
}
